import { combineReducers } from 'redux';

import selected from './selected';

const filters = combineReducers({
  selected,
});

export default filters;
